import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { WorkflowStepInputOutput } from "@/components/custom/AlertDialogButton/WorkflowStepInputOutput"

export const InputOutputLegacy = ({
  className,
  title,
  subtitle,
  variant
}: {
  className?: string,
  title: string,
  subtitle: string,
  variant?: 'primary' | 'secondary'
}) => {

  const tagVariants = cva(
    "h-[36px] px-3 flex items-center justify-center font-semibold text-sm tracking-wider mr-3",
    {
      variants: {
        variant: {
          default: "bg-tag-primary",
          primary:
            "bg-tag-primary",
          secondary:
            "bg-tag-secondary ml-3"
        },
      },
      defaultVariants: {
        variant: "default",
      },
    }
  )
  return (
    <div className={`flex flex-row items-center ${className}`}>
      <div className={cn(tagVariants({ variant }))}>
        {title}
      </div>
      {subtitle !== 'N/A' ? (
        <WorkflowStepInputOutput
          title={title}
          description={subtitle}
        />
      ) : <p className="text-primary">{subtitle}</p>}
    </div>
  )
}
